import {Outlet} from 'react-router-dom';
const DashboardUser = (props) => {
  return <Outlet/>;
};

export default DashboardUser;
